import { SVGProps } from 'react';

const SvgDownloadSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} fill="none" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M7.309 10.962a.5.5 0 0 0 .545-.108l4-4a.5.5 0 0 0-.708-.708L8 9.293V1.5a.5.5 0 0 0-1 0v7.793L3.854 6.146a.5.5 0 1 0-.708.708l4 4a.5.5 0 0 0 .163.108ZM2 14.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5Z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgDownloadSmall;
